import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Dropdown, Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { server } from "../../config/vars";
import {
  getDevices,
  selectDevice,
} from "../Votify/VotifyHost/hostActionCreators";
import DevicesMenu from "../Votify/VotifyHost/DevicesMenu";
import PlaylistsMenu from "../Votify/VotifyHost/PlaylistsMenu";
import PartyNameForm from "../Votify/VotifyHost/PartyNameForm";
import VotifySharePartyModal from "../Votify/PartyLayout/VotifySharePartyModal";

const FullScreenMenuComponent = ({ isHost, partyUrl, partyName }) => {
  if (isHost) {
    return (
      <Menu fluid vertical inverted size={"massive"} style={style.menu}>
        <Menu.Item name="share">
          <VotifySharePartyModal
            trigger={<span>Share</span>}
            partyUrl={partyUrl}
          />
        </Menu.Item>
        <Menu.Item name="party-name">
          <PartyNameForm />
        </Menu.Item>
        <Menu.Item
          as={"a"}
          href={`${server.uri}/v1/auth/spotify`}
          name="reconnect"
        >
          Reconnect to Spotify
        </Menu.Item>
        <Menu.Item name="devices">
          Devices
          <DevicesMenu as={Dropdown.Item} />
        </Menu.Item>
        <Menu.Item name="playlists">
          Playlists
          <PlaylistsMenu />
        </Menu.Item>
      </Menu>
    );
  } else {
    return (
      <Menu fluid vertical inverted size={"massive"} style={style.menu}>
        <Menu.Item name="home" as={Link} to={`/p/${partyName}`} replace>
          Currently joined party <strong>{partyName}</strong>
        </Menu.Item>
        <Menu.Item name="share">
          <VotifySharePartyModal
            trigger={<span>Share</span>}
            partyUrl={partyUrl}
          />
        </Menu.Item>
      </Menu>
    );
  }
};

const style = {
  menu: {
    maxWidth: "768px",
    marginLeft: "auto",
    marginRight: "auto",
  },
};

const mapStateToProps = (state) => {
  return {
    isHost: state.party.partyId === state.host.partyId,
    partyUrl: state.party.partyUrl,
    partyName: state.party.partyName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectDevice: (device) => dispatch(selectDevice(device)),
    loadDevices: () => dispatch(getDevices()),
  };
};

FullScreenMenuComponent.propTypes = {
  isHost: PropTypes.bool.isRequired,
  partyUrl: PropTypes.string.isRequired,
  partyName: PropTypes.string.isRequired,
  selectDevice: PropTypes.func.isRequired,
  loadDevices: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FullScreenMenuComponent);
